import React, { Component } from 'react'
import { COLORES } from '../../../../../config/colores'
import { Card, Row, Container, Col } from 'react-bootstrap'
import { CardActionArea } from '@material-ui/core'
import HeaderApp from '../../../../LaridaeApp/components/HeaderApp'

class PreIngresoCalado0 extends Component {
  componentDidMount () {
    const { reloadState } = this.props
    if (reloadState) {
      window.location.reload()
    }
  }

  componentDidUpdate () {
    const { reloadState } = this.props
    if (reloadState) {
      window.location.reload()
    }
  }

  render () {
    const {
      calleA,
      calleB
    } = this.props

    return (

      <>
        <div className='App-header-panel'>
          <HeaderApp hideButton />
        </div>

        <Container fluid className='align-items-center container-card-calado-preingreso'>
          <Col>
            <h3 className='text-title-preingreso'>Seleccione la calle en la que se encuentra</h3>
            <h4>luego deberá escanear el código QR en la parte inferior del panel</h4>
          </Col>
          <Row className='justify-content-center container-flechas-preingreso'>
            <div className='triangulo' style={{ transform: 'rotate(180deg)' }} />
            <Col md={4} style={{ paddingLeft: '10px', paddingRight: '10px', marginRight: '3%' }}>
              <Card style={{ backgroundColor: COLORES.blue.primary }} className='card-calle shadow rounded card-calle-preingreso'>
                <CardActionArea style={{ margin: 'auto 0' }} onClick={() => this.props.updateCallePreIngreso(calleA)}>
                  <Card.Body className='body-flecha-preingreso'>
                    <Card.Title className='card-title-preingreso'>
                      Calle {calleA}
                    </Card.Title>
                  </Card.Body>
                </CardActionArea>
              </Card>
            </Col>
            <Col md={4} style={{ paddingLeft: '10px', paddingRight: '10px', marginLeft: '3%' }}>
              <Card style={{ backgroundColor: COLORES.blue.primary }} className='card-calle shadow rounded card-calle-preingreso'>
                <CardActionArea style={{ margin: 'auto 0' }} onClick={() => this.props.updateCallePreIngreso(calleB)}>
                  <Card.Body className='body-flecha-preingreso'>
                    <Card.Title className='card-title-preingreso'>
                      Calle {calleB}
                    </Card.Title>
                  </Card.Body>
                </CardActionArea>
              </Card>
            </Col>
            <div className='triangulo' />
          </Row>
        </Container></>

    )
  }
}

export default PreIngresoCalado0
